module.exports = __webpack_public_path__ + "media/images/page/top/top_img_05-b48a72fe003a514d27ac352ad5102b92.png";